(function () {
    'use strict';

    angular
        .module('franchiser.services')
        .service('PermissionGroupService', PermissionGroupService)

    /** @ngInject */
    function PermissionGroupService(HttpService) {
        const PermissionGroupService = {
            get,
            getAll,
            getByParameters,
            getPermissions,
            post,
            postPermissions,
            put,
            migrateData,
            deleteData
        }

        return PermissionGroupService;

        function get(id) {
            return HttpService.get(`/permission-groups/${id}`);
        }

        function getAll() {
            return HttpService.get('/permission-groups/by-parameters', {
                params: {
                    PerPage: null,
                    Skip: null,
                    OrderDescending: false
                }
            });
        }

        function getByParameters(params) {
            return HttpService.get('/permission-groups/by-parameters', {
                params
            });
        }

        function getPermissions(permissionGroupId) {
            return HttpService.get(`/permission-group-module/${permissionGroupId}`);
        }

        function post(permissionGroupData) {
            return HttpService.post(`/permission-groups`, permissionGroupData);
        }

        function postPermissions(permissionGroupPermissions, permissionGroupId) {
            return HttpService.post(`/permission-group-module/${permissionGroupId}`, permissionGroupPermissions);
        }

        function put(permissionGroupData) {
            return HttpService.put(`/permission-groups`, permissionGroupData);
        }

        function migrateData(permissionGroupOriginId, permissionGroupDestinationId) {
            return HttpService.put(`/permission-groups/migrate/${permissionGroupOriginId}/${permissionGroupDestinationId}`);
        }

        function deleteData(permissionGroupId) {
            return HttpService.delete(`/permission-groups/${permissionGroupId}`);
        }
    }
}());